import { CLASS_ROUTE } from "@/constant/urlConstant";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const CoursesSearchForm = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const q = searchParams.get("q") || "";
  const [searchKeyword, setSearchKeyword] = useState<string>(q);

  useEffect(() => {
    setSearchKeyword(searchParams.get("q") || "");
  }, [searchParams]);

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    const {
      currentTarget: { value },
    } = event;
    setSearchKeyword(value);
  };

  const clearSearch = () => {
    setSearchKeyword("");
    const params = new URLSearchParams(searchParams);
    params.delete("q");
    const query = params.toString();
    navigate(`/${CLASS_ROUTE}/search${query ? `?${query}` : ""}`);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (searchKeyword === "") {
      clearSearch();
      return;
    }
    const params = new URLSearchParams(searchParams);
    params.set("q", searchKeyword);
    navigate(`/${CLASS_ROUTE}/search?${params}`);
  };

  return (
    <form className="relative" onSubmit={handleSubmit}>
      <i className="ii ii-search z-[10] absolute top-[10px] left-[12px] h-[20px] leading-[20px] text-[20px] text-medi-text-secondary"></i>
      <input
        className="flex items-center w-full bg-gray-50 focus:bg-white focus:drop-shadow-md h-[44px] px-[40px] rounded-md text-[16px] placeholder:text-medi-text-placeholder"
        type="text"
        value={searchKeyword}
        placeholder="검색어를 입력해주세요."
        onChange={handleChange}
        onBlur={(e) => {
          if (e.target.value) return;
          clearSearch();
        }}
      />
      {searchKeyword && (
        <button
          className="absolute top-0 right-0 w-[40px] h-[40px]"
          type="button"
          onClick={clearSearch}
        >
          <i className="ii ii-remove text-[20px] text-gray-800"></i>
        </button>
      )}
      <button className="hidden" type="submit">
        검색
      </button>
    </form>
  );
};

export default CoursesSearchForm;
